import _classCallCheck from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/cheisler/workspace/my.phone.com/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { NonInviteClientTransaction } from "../transactions";
import { UserAgentClient } from "./user-agent-client";
/**
 * PUBLISH UAC.
 * @public
 */

export var PublishUserAgentClient = /*#__PURE__*/function (_UserAgentClient) {
  _inherits(PublishUserAgentClient, _UserAgentClient);

  function PublishUserAgentClient(core, message, delegate) {
    _classCallCheck(this, PublishUserAgentClient);

    return _possibleConstructorReturn(this, _getPrototypeOf(PublishUserAgentClient).call(this, NonInviteClientTransaction, core, message, delegate));
  }

  return PublishUserAgentClient;
}(UserAgentClient);